import superagent from 'superagent'

export const storeFCMToken = token => {
  return {
    type: 'STORE_FCMTOKEN',
    payload: token
  }
}

export const cleanFirebase = (token) => {
  console.log('get cleared')
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/firebase/clean`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          console.error('Clean Firebase Error:')
          reject(err)
        } else {
          resolve(res)
        }
      })
  })
}

let retryCount = 1
export const sendTokenToAPI = firebaseObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    if (token) {
      superagent
        .post(`${__API_URI__}/firebase/token`)
        .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send(JSON.stringify(firebaseObj))
        .end((err, res) => {
          if (err) {
            if (err.status == 400 && retryCount > 0) {
              --retryCount
              cleanFirebase(token)
                .then(() => {
                  dispatch(sendTokenToAPI(firebaseObj))
                })
                .catch(err => {
                  reject(err)
                })
            }
            else {
              reject(err)
            }
          } else {
            resolve(res)
          }
        })
    } else {
      reject(null)
    }
  })
}
